module.exports = __webpack_public_path__ + "img/401.8ace4e45.png";